import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { CountryString } from '../../types/Country';
import { CurrencyString } from '../../types/Currency';
import { parseFloatAmount } from '../amount';
import { VALIDATION_RULES } from './constants';
import { ValidationRules } from './types';

export function validateByMethodName(params: {
  paymentMethod: PaymentMethod;
  currency: CurrencyString;
  amount: string;
  country: CountryString;
  locale: string;
}): boolean {
  const { paymentMethod, currency, amount, country, locale } = params;
  return validate({
    validationRules: VALIDATION_RULES[paymentMethod],
    currency,
    amount,
    country,
    locale,
  });
}

export function validate(params: {
  validationRules: ValidationRules;
  currency: CurrencyString;
  amount: string;
  country: CountryString;
  locale: string;
}): boolean {
  const { validationRules, currency, amount, locale } = params;

  if (!validationRules || !Object.keys(validationRules).length) {
    return true;
  }

  if (validationRules?.locales && !validationRules?.locales?.includes(locale)) {
    return false;
  }

  if (validationRules?.currencies && !validationRules?.currencies?.includes(currency)) {
    return false;
  }

  return validateAmount(
    amount,
    getMinOrMaxValue(validationRules?.min, currency),
    getMinOrMaxValue(validationRules?.max, currency),
  );
}

export function validateAmount(amount: string, min = 0, max?: number): boolean {
  const amountNumber = parseFloatAmount(amount);

  if (!amountNumber) {
    return false;
  }

  if (amountNumber < min) {
    return false;
  }

  if (max && amountNumber > max) {
    return false;
  }

  return true;
}

function getMinOrMaxValue(rule: ValidationRules['min'] | ValidationRules['max'], currency: CurrencyString) {
  return typeof rule === 'number' ? rule : rule?.[currency];
}
